import type { SwitchProps } from '@mantine/core';
import { Switch } from '@mantine/core';
import React from 'react';

import styles from './Switcher.module.css';

export const LBSwitcher = React.forwardRef<
  React.ElementRef<typeof Switch>,
  SwitchProps
>((props, ref) => <Switch {...props} ref={ref} classNames={styles} />);
